import gql from 'graphql-tag';

export const getChallengeQuery = gql`
	query GetChallenge($id: ID) {
		challenge(id: $id) {
			id
			opponent {
				id
				name
				slug
				username
				avatarImg
			}
			challenger {
				id
				name
				slug
				username
				avatarImg
			}
			matches {
				id
			}
			gameType
			matchFormat
			raceTo
			league {
				id
				name
				slug
				type
			}
			location {
				id
				slug
				name
				address
				city
				state
				zip
				country
			}
			division {
				id
				slug
				name
				type
			}
			comments {
				id
				message
				author {
					id
					name
					username
					avatarImg
				}
			}
			commentCount
			startTime
			notes
			accepted
			status
			createdAt
			updatedAt
		}
	}
`;
